<h2 mat-dialog-title>{{'heizcheck.foto.overlay.preview.title' | translate}}</h2>
<mat-dialog-content class="mat-typography">
  <p [class.loading]="data.loading" [innerHTML]="'heizcheck.foto.overlay.preview.body' | translate"></p>
  <ul class="image-preview-list">
    @for (image of data.images; track image) {
      <li>
        <img src="{{image}}" alt="">
      </li>
    }
    <li class="dummy" [class.loading]="data.loading"><i class="icon-camera"></i>
    @if (!data.loading) {
      {{'heizcheck.foto.overlay.preview.page' | translate: {'page': data.images.length + 1} }}
    }
    @if (data.loading) {
      {{'heizcheck.foto.overlay.preview.camera' | translate: {'page': data.images.length + 1} }}
    }
  </li>
</ul>
</mat-dialog-content>
